export default () => {
  const video_players = document.querySelectorAll('.js-video-player');
  if (video_players) {
    video_players.forEach(element => {
      if (element.dataset.poster) {
        element.style.backgroundImage = `url(${element.dataset.poster})`;
      }
      const vide_wrapper = element.querySelector('.Video__Wrapper');
      const play_btn = element.querySelector('.js-video-player-btn');
      if (play_btn) {

        play_btn.addEventListener('click', e => {
          e.preventDefault();
          element.classList.add('is-playing');
          if (element.dataset.provider === 'self') {
            element.querySelector('video').play();
          } else {
            element.querySelector('iframe').src = element.querySelector('iframe').dataset.src;
          }
          vide_wrapper.classList.add('is-active');
          play_btn.style.display = 'none';
        })

        if (element.dataset.provider === 'self') {   
          let player = element.querySelector('video');     
          player.addEventListener('play', () => {
            play_btn.style.display = 'none';
          })
          player.addEventListener('pause', () => {
              play_btn.style.display = 'flex';
              element.classList.remove('is-playing');
          });
        }
      }
    });
  }

}